import { useCallback, useEffect, useMemo } from 'react'

import classNames from 'classnames'

import { Icon } from '@lib/components'

import styles from './styles.module.scss'
import { ToastProps } from './types'
import { IconStyles } from '../Icon/styles'

export const Toast = ({ notification, dismiss }: ToastProps) => {
  useEffect(() => {
    const duration = notification.delay || 5000
    if (duration > 0) {
      const timerId = setTimeout(() => dismiss(notification.id), duration)
      return () => clearTimeout(timerId)
    }
    return
  }, [notification, dismiss])

  const toastClassNames = useMemo(
    () => classNames(styles.toastItem, styles[notification.kind]),
    [notification.kind]
  )

  const onClickHandler = useCallback(
    () => dismiss(notification.id),
    [notification]
  )

  return (
    notification.message && (
      <div className={toastClassNames}>
        <div className={styles.icon}>
          <Icon
            path="icons/icon-notification-error"
            style={IconStyles.medium}
          />
        </div>
        <div className={styles.message}>{notification.message}</div>
        <div className={styles.closeButton} onClick={onClickHandler}>
          <Icon
            path="icons/icon-close-notification-error"
            style={IconStyles.small}
          />
        </div>
      </div>
    )
  )
}
